import { Button, Nav, NavItem } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
/*import user1 from "../assets/images/users/user4.jpg";*/
/*import probg from "../assets/images/bg/download.jpg";*/
//import bedbug from "../assets/images/bedbug.png";
import dashbooard_img from "../assets/images/dashboard.png";
//import mosquito from "../assets/images/mosquito.png";
/*import analise from "../assets/images/analise.png";*/
//import skin from "../assets/images/skin.png";
//import leish from "../assets/images/leish.png";
import ref from "../assets/images/ref.png";
//import pulm from "../assets/images/pulmao.png";
import report from "../assets/images/report.png"
//import { Collapse } from '@mui/material';
import React, { useState } from 'react';
import CaixaCinzaLC from "../components/CaixaCinzaLC";



/* const navigation = [
  {
    title: "Dashboards",
    href: "/starter",
    icon: dashbooard_img,
  },
  {
    title: "Boletins",
    href: "/boletins",
    icon: report,
  }

]; */

let nav_linhas = [
  {
   title: "Referências",
   href: "/referencias",
   icon: ref,
 },
 

];

let nav_linhasTB = [
  {
   title: "Referências",
   href: "/refTB",
   icon: ref,
 },
 

];



const breakpoint = 700; // Defina o ponto de corte desejado (por exemplo, 700px)
if (window.innerWidth < breakpoint) {
  nav_linhas = [
    {
     title: "Referências",
   href: "/referencias",
   icon: ref,
   },
 
 ];

 let nav_linhasTB = [
  {
   title: "Referências",
   href: "/refTB",
   icon: ref,
 },
];
 

} else {
  nav_linhas = [
    {
     title: "Referências",
   href: "/refhans",
   icon: ref,
   },
   
 
 ];
 let nav_linhasTB = [
  {
   title: "Referências",
   href: "/refTB",
   icon: ref,
 },
];
}

/* const nav_linhas = [
   {
    title: "Doença de Chagas",
    href: "/chagas1",
    icon: bedbug,
  },
  {
    title: "Calazar",
    href: "/calazar1",
    icon: mosquito,
  },
  {
    title: "Leishmaniose",
    href: "/Leish1",
    icon: leish,
  }, 
  {
    title: "Hanseníase",
    href: "",
    icon: skin,
    id: 1,
    collapisble: true,
    filhos: 1,
  },
  {
    title: "Tuberculose",
    href: "/turb1",
    icon: pulm,
  },

]; */

const hans_children = [
  {
    title: "Completo",
    href: "/hans01_G",
    icon: dashbooard_img,
  },
  {
    title: "Partes",
    href: "/hans01",
    icon: report,
  },
  {
    title: "Tela Cheia",
    href: "/hans01",
    icon: report,
  }

];



const Legendas = () => {
 /* const showMobilemenu = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };*/

 
  const [mostra, setMostra] = useState('none');
  function handleMouseClick (index) {
    if (mostra === 'none') {
        setMostra('block'); 
    } else {
      setMostra('none'); 
    }
    
  };


  /* const [visibleIndex, setVisibleIndex] = useState(null);

  const toggleVisibility = (index) => {
    if (visibleIndex === index) {
      setVisibleIndex(null); // Fecha o submenu se ele já estiver aberto
      alert('fecha ', index)
    } else {
      setVisibleIndex(index); // Abre o submenu
      alert('abre', index)
    }
  };
   */
  let location = useLocation();

  return (
    <div >
      <div className="d-flex align-items-center"></div>
      {/*}
          <div
            className="profilebg"
            style={{ background: `url(${probg}) no-repeat` }}
          >
            <div className="p-3 d-flex">
              <img src={user1} alt="user" width="50" className="rounded-circle" />
              <Button
                color="white"
                className="ms-auto text-white d-lg-none"
                onClick={() => showMobilemenu()} 
              >
                <i className="bi bi-x"></i>
              </Button>
            </div>
            <div className="bg-dark text-white p-2 opacity-75">Steave Rojer</div>
          </div>
      */}

      <div className="p-3 mt-2">
        
          {/* <><><><><><> Menu de Hanseníase <><><><><><> */}
          {(location.pathname === '/hans_Geral' || location.pathname === '/refhans') && (

            <>
              
            <Nav vertical className="sidebarNav" style={{"background": "#f9ecb7"}} >

              <Button
                  color="warning"
                  tag="a"
                  target="_blank"
                  className="mt-3"
                  disabled
                >
              Legendas
                </Button>
              
              <CaixaCinzaLC text={[<center><h6><u>SIGLAS</u></h6></center>,
                                  <b>ANS</b>,' - Avaliação Neurológica Simplificada',<br/>, <br/>,
                                  <b>APS</b>,' - Atenção Primária Saúde',<br/>, <br/>,
                                  <b>IB</b>,' - Índice Baciloscópico',<br/>,<br/>,
                                  <b>MB</b>,' - Multibacilar',<br/>,<br/>,
                                  <b>PCDT</b>,' - Protocolo clinico diretrizes terapeuticas hanseniase',<br/>,<br/>,
                                  <b>PB</b>,' - Paucibacilar',<br/>,<br/>,
                                  <b>PQT-U</b>,' - Poliquimioterapia Única',<br/>,<br/>,
                                  <b>SINAN</b>,' - Sistema de Informação informação de agravos de notificação'
                                          
                                          ]} tam='12px'/>
              
              
              <CaixaCinzaLC text={[<center><h6><u>PONTOS DE ATENÇÃO</u></h6></center>,
                                  <b>CEIR</b>,' - Centro Integrado de Reabilitação',<br/>, <br/>,
                                  <b>CMI</b>,' - Centro Maria Imaculada',<br/>, <br/>,
                                  <b>HILP</b>,' - Hospital Infantil Lucídio Portela',<br/>,<br/>,
                                  <b>MB</b>,' - Multibacilar',<br/>,<br/>,
                                  <b>HMP</b>,' - Hospital da Policia Militar',<br/>,<br/>,
                                  <b>HU</b>,' - Hospital Universitário',<br/>,<br/>,
                                          
                                          ]} tam='12px'/>

              <CaixaCinzaLC text={[<center><h6><u>PONTOS DE ATENÇÃO</u></h6></center>,
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <div style={{
                                        width: '30px',
                                        height: '30px',
                                        border: '4px solid green',
                                        backgroundColor: 'transparent'
                                      }}></div>
                                      <span style={{ fontSize: '12px' }}>ATENÇÃO PRIMÁRIA</span>
                                  </div>,<br/>,
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <div style={{
                                        width: '30px',
                                        height: '30px',
                                        border: '4px solid yellow',
                                        backgroundColor: 'transparent'
                                      }}></div>
                                      <span style={{ fontSize: '12px' }}>ATENÇÃO SECUNDÁRIA</span>
                                  </div>,<br/>,
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <div style={{
                                        width: '30px',
                                        height: '30px',
                                        border: '4px solid red',
                                        backgroundColor: 'transparent'
                                      }}></div>
                                      <span style={{ fontSize: '12px' }}>ATENÇÃO TERCIÁRIA</span>
                                  </div>

                                          ]} tam='12px'/>
            
          
              {nav_linhas.map((navi, index) => (
                      <div>

                          {navi.filhos === '1' ? <div>
                            
                            <NavItem key={index} className="sidenav-bg" onClick={() => handleMouseClick(index)}>
                                <Link
                                  to={navi.href}
                                  className={
                                    location.pathname === navi.href
                                      ? "active nav-link py-3"
                                      : "nav-link text-secondary py-3"
                                  }
                                >
                                  <img alt="icon" src={navi.icon} width={"10%"}></img>
                                  <span className="ms-3 d-inline-block">{navi.title}</span>
                                </Link>
                              </NavItem>


                            {hans_children.map((navi, index) => (
                              <div>
                                  
                                  <NavItem id={index} className="sidenav-bg" style={{ display: mostra }} >
                                      <Link
                                        to={navi.href}
                                        className={
                                          location.pathname === navi.href
                                            ? "active nav-link py-3"
                                            : "nav-link text-secondary py-3"
                                        }
                                      >
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {/* <img alt="icon" src={navi.icon} width={"10%"}></img> */}
                                        <span className="ms-3 d-inline-block">{navi.title}</span>
                                      </Link>

                                    

                                  </NavItem>
                              </div>
                    
                            ))}
                          
                            
                            </div> : <div>

                                          <NavItem key={index} className="sidenav-bg">
                                                <Link
                                                  to={navi.href}
                                                  className={
                                                    location.pathname === navi.href
                                                      ? "active nav-link py-3"
                                                      : "nav-link text-secondary py-3"
                                                  }
                                                >
                                                  <img alt="icon" src={navi.icon} width={"10%"}></img>
                                                  <span className="ms-3 d-inline-block">{navi.title}</span>
                                                </Link>
                                          </NavItem>

                                    </div>
                            
                          }

                      </div>
                ))}

            <Button
                color="ciaten-warning"
                tag="a"
                target="_blank"
                className="mt-3"
                href="https://ciaten.org.br"
              >
                Sobre o CIATEN
              </Button>
            </Nav>
          
          </>)}

           {/* <><><><><><> Menu de TB <><><><><><> */}
          {(location.pathname === '/TB_Geral' ||  location.pathname === '/refTB') && (

            <>
              
            <Nav vertical className="sidebarNav" style={{"background": "#f9ecb7"}} >

              <Button
                  color="warning"
                  tag="a"
                  target="_blank"
                  className="mt-3"
                  disabled
                >
              Legendas
                </Button>
              
              <CaixaCinzaLC text={[<center><h6><u>SIGLAS</u></h6></center>,
                                  <b>APS</b>,' - Atenção Primária Saúde',<br/>, <br/>,
                                  <b>BK</b>,' - Bacilo de Koch (baciloscopia)',<br/>, <br/>,
                                  <b>CTA</b>,' - Centro de Testagem e Aconselhamento',<br/>, <br/>,
                                  <b>ILTB</b>,' - Infecção Latente da Tuberculose',<br/>, <br/>,
                                  <b>IGRA</b>,' - Interferon Gama Release Assay',<br/>, <br/>,
                                  <b>LPA</b>,' - Line Probe Assay',<br/>, <br/>,
                                  <b>LF-LAM</b>,' - Lipoarabinomanano',<br/>, <br/>,
                                  <b>TRM</b>,' - Teste Rápido Molecular',<br/>, <br/>,
                                  <b>TS</b>,' - Teste de Sensibilidade',<br/>, <br/>,
                                  <b>TB</b>,' - Tuberculose',<br/>, <br/>,
                                  <b>TPT</b>,' - Tratamento Preventivo da Tuberculose',<br/>, <br/>,
                                  <b>SINAN</b>,' - Sistema de Informação informação de agravos de notificação',<br/>, <br/>,
                                  <b>PT ou PPD</b>,' - Prova tuberculínica ou Derivado proteico purificado',<br/>, <br/>,
                                  <b>SAE</b>,' - Serviço de Assitência Especializada',<br/>, <br/>,
                                  <b>SITE-TB</b>,' - Sistema de informação de tratamentos especiais da tuberculose',<br/>, <br/>,
                                          
                                          ]} tam='12px'/>
              
              
              <CaixaCinzaLC text={[<center><h6><u>PONTOS DE ATENÇÃO</u></h6></center>,
                                  <b>HGV</b>,' - Hospital Getúlio Vargas',<br/>, <br/>,
                                  <b>HILP</b>,' - Hospital Infantil Lucídio Portela',<br/>, <br/>,
                                  <b>HU</b>,' - Hospital Universitário',<br/>, <br/>,
                                  <b>HILP</b>,' - Hospital Infantil Lucídio Portela',<br/>,<br/>,
                                  <b>IDTNP</b>,' - Instituto de Doenças Tropicais Natan Portella',<br/>,<br/>,
                                          
                                          ]} tam='12px'/>

              <CaixaCinzaLC text={[<center><h6><u>LEGENDAS</u></h6></center>,
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <div style={{
                                        width: '30px',
                                        height: '30px',
                                        border: '4px solid green',
                                        backgroundColor: 'transparent'
                                      }}></div>
                                      <span style={{ fontSize: '12px' }}>ATENÇÃO PRIMÁRIA</span>
                                  </div>,<br/>,
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <div style={{
                                        width: '30px',
                                        height: '30px',
                                        border: '4px solid yellow',
                                        backgroundColor: 'transparent'
                                      }}></div>
                                      <span style={{ fontSize: '12px' }}>ATENÇÃO SECUNDÁRIA</span>
                                  </div>,<br/>,
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <div style={{
                                        width: '30px',
                                        height: '30px',
                                        border: '4px solid red',
                                        backgroundColor: 'transparent'
                                      }}></div>
                                      <span style={{ fontSize: '12px' }}>ATENÇÃO TERCIÁRIA</span>
                                  </div>

                                          ]} tam='12px'/>
            
          
              {nav_linhasTB.map((navi, index) => (
                      <div>

                          {navi.filhos === '1' ? <div>
                            
                            <NavItem key={index} className="sidenav-bg" onClick={() => handleMouseClick(index)}>
                                <Link
                                  to={navi.href}
                                  className={
                                    location.pathname === navi.href
                                      ? "active nav-link py-3"
                                      : "nav-link text-secondary py-3"
                                  }
                                >
                                  <img alt="icon" src={navi.icon} width={"10%"}></img>
                                  <span className="ms-3 d-inline-block">{navi.title}</span>
                                </Link>
                              </NavItem>


                            {hans_children.map((navi, index) => (
                              <div>
                                  
                                  <NavItem id={index} className="sidenav-bg" style={{ display: mostra }} >
                                      <Link
                                        to={navi.href}
                                        className={
                                          location.pathname === navi.href
                                            ? "active nav-link py-3"
                                            : "nav-link text-secondary py-3"
                                        }
                                      >
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {/* <img alt="icon" src={navi.icon} width={"10%"}></img> */}
                                        <span className="ms-3 d-inline-block">{navi.title}</span>
                                      </Link>

                                    

                                  </NavItem>
                              </div>
                    
                            ))}
                          
                            
                            </div> : <div>

                                          <NavItem key={index} className="sidenav-bg">
                                                <Link
                                                  to={navi.href}
                                                  className={
                                                    location.pathname === navi.href
                                                      ? "active nav-link py-3"
                                                      : "nav-link text-secondary py-3"
                                                  }
                                                >
                                                  <img alt="icon" src={navi.icon} width={"10%"}></img>
                                                  <span className="ms-3 d-inline-block">{navi.title}</span>
                                                </Link>
                                          </NavItem>

                                    </div>
                            
                          }

                      </div>
                ))}

            <Button
                color="ciaten-warning"
                tag="a"
                target="_blank"
                className="mt-3"
                href="https://ciaten.org.br"
              >
                Sobre o CIATEN
              </Button>
            </Nav>
          
          </>)}




            
          
      </div>
    </div>
  );
};

export default Legendas;
